import { InjectionToken } from "@angular/core";

export interface Options {
  baseUrl: string
  signInPolicy: string
  apiBaseUrl: string
  msalConfig: MsalConfig
}

export interface MsalConfig {
  auth: Auth
  cache: Cache
}

export interface Auth {
  clientId: string
  authority: string
  knownAuthorities: string[]
  redirectUri: string
  postLogoutRedirectUri: string
}

export interface Cache {
  cacheLocation: string
}

export interface ClientOptions {
  applicationId: string
  msalResourceMap: [string, string[]][]
  organizationId: any
}

export type ClientConfig = {
    clientOptions: ClientOptions;
    options: Options;
  };

export const CLIENT_CONFIG: InjectionToken<ClientConfig> =
new InjectionToken<ClientConfig>('Client Config');
